import Grid from '@material-ui/core/Grid'
import { createStyles, makeStyles } from '@material-ui/styles'
import React from 'react'
import { ObjectFieldTemplateProps } from 'react-jsonschema-form'

import { Theme } from '../../../lib/theming/Theme'

const useStyles = makeStyles<Theme>(theme =>
  createStyles({
    propertyElement: {
      marginBottom: theme.spacing(1),
    },
    root: {},
  })
)

const ObjectFieldTemplate = ({
  DescriptionField,
  description,
  TitleField,
  title,
  properties,
  required,
  uiSchema,
  idSchema,
}: ObjectFieldTemplateProps) => {
  const classes = useStyles()

  return (
    <>
      {(uiSchema['ui:title'] || title) && (
        <TitleField id={`${idSchema.$id}-title`} required={required} title={title} />
      )}

      {description && (
        <DescriptionField description={description} id={`${idSchema.$id}-description`} />
      )}

      <Grid container className={classes.root} spacing={2}>
        {properties.map(element => (
          <Grid key={element.name} item className={classes.propertyElement} xs={12}>
            {element.content}
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default ObjectFieldTemplate
